import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { TopTestimonials } from './components/TopTestimonials';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { Modules } from './components/Modules';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="86mh792mi8x9">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="8648hcyry28g" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-2" data-mp="3bk718hkvi07g">
        <main data-id="element-3" data-mp="3qbzfeq8xl87l">
          <Hero data-id="element-4" data-mp="3qcinzgcoyk8y" />
          <StatsStrip data-id="element-5" data-mp="3qd0st1df66sh" />
          <TopTestimonials data-id="element-6" data-mp="3lkr2vlcb16q7" />
          <PainSection data-id="element-7" data-mp="3ljfzhmmru0zm" />
          <SystemSection data-id="element-8" data-mp="3lj6cm7x0w9y5" />
          <Modules data-id="element-9" data-mp="2xuwv3i6ue8ct" />
          <BonusSection data-id="element-10" data-mp="2xud9nrhzh1u1" />
          <UrgencySection data-id="element-11" data-mp="2xtlrbided0lp" />
          <Offer data-id="element-12" data-mp="2xssga57enoxr" />
          <Testimonials data-id="element-13" data-mp="2svtnpr3e3q1o" />
          <Guarantee data-id="element-14" data-mp="2swbu3gjrnknb" />
          <FAQ data-id="element-15" data-mp="2sv0p5del46um" />
          <Comparison data-id="element-16" data-mp="2svaecyrt29z9" />
          <FinalCTA data-id="element-17" data-mp="2stzc53e0daa9" />
        </main>
        <Footer data-id="element-18" data-mp="18dhr21p28w4y" />
        <PurchasePopup data-id="element-19" data-mp="18czm8goc19lf" />
      </div>
    </>;
}